var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 30,
    viewBox: "0 0 71 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.584656V29.4073H9.7791V11.9078L23.6757 29.4073H37.0576V11.3931H27.2785V17.5694L13.3819 0.584656H0Z",
    fill: "#FF5C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6083 1.09967H27.2785V9.33477H55.0642C62.7846 9.33477 61.7627 21.6951 54.557 21.6951H39.1163V29.4153H56.1011C76.174 26.3272 73.0784 0.584981 56.6083 1.09967Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewlogo);
export default __webpack_public_path__ + "static/media/newlogo.2d2e86d4e0eb3f973df4bf2cf32b013c.svg";
export { ForwardRef as ReactComponent };